import {
  PESQUISAS_PRINCIPAL,
  PESQUISAS_INDICADORES,
  PESQUISAS_ATIVOS,
  PESQUISAS_PESSOAS,
  PESQUISAS_GESTORES,
  PESQUISAS_ADMINISTRADORES,
  PESQUISAS_LOGOUT,
} from "../../const/actionsType";
import { dates } from "investira.sdk";

const INITIAL_STATE = {
  global: {
    pesquisa: "",
    resultado: {},
    filtros: {},
    updatedAt: null,
  },
  indicadores: {
    pesquisa: "",
    resultado: {},
    filtros: {},
    updatedAt: null,
  },
  ativos: {
    pesquisa: "",
    resultado: {},
    filtros: {},
    updatedAt: null,
  },
  empresas: {
    pesquisa: "",
    resultado: {},
    filtros: {},
    updatedAt: null,
  },
  gestores: {
    pesquisa: "",
    resultado: {},
    filtros: {},
    updatedAt: null,
  },
  administradores: {
    pesquisa: "",
    resultado: {},
    filtros: {},
    updatedAt: null,
  },
};

function pesquisasReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case PESQUISAS_PRINCIPAL:
      return {
        ...state,
        global: {
          pesquisa: action.payload.pesquisa,
          resultado: action.payload.resultado,
          filtros: state?.global?.filtros,
          updatedAt: dates.toDate(),
        },
      };

    case PESQUISAS_INDICADORES:
      return {
        ...state,
        indicadores: {
          pesquisa: action.payload.pesquisa,
          resultado: action.payload.resultado,
          filtros: state?.indicadores?.filtros,
          updatedAt: dates.toDate(),
        },
      };

    case PESQUISAS_ATIVOS:
      return {
        ...state,
        ativos: {
          pesquisa: action.payload.pesquisa,
          resultado: action.payload.resultado,
          filtros: state?.ativos?.filtros,
          updatedAt: dates.toDate(),
        },
      };

    case PESQUISAS_PESSOAS:
      return {
        ...state,
        empresas: {
          pesquisa: action.payload.pesquisa,
          resultado: action.payload.resultado,
          filtros: state?.empresas?.filtros,
          updatedAt: dates.toDate(),
        },
      };

    case PESQUISAS_GESTORES:
      return {
        ...state,
        gestores: {
          pesquisa: action.payload.pesquisa,
          resultado: action.payload.resultado,
          filtros: state?.gestores?.filtros,
          updatedAt: dates.toDate(),
        },
      };

    case PESQUISAS_ADMINISTRADORES:
      return {
        ...state,
        administradores: {
          pesquisa: action.payload.pesquisa,
          resultado: action.payload.resultado,
          filtros: state?.administradores?.filtros,
          updatedAt: dates.toDate(),
        },
      };

    case PESQUISAS_LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default pesquisasReducer;
